export default __webpack_public_path__ + "static/media/FileGroup.c5434bab.svg";